<script setup lang="ts">
    import { InfoIcon } from '@lucide/vue';

    withDefaults(defineProps<{ size?: 'default' | 'small' }>(), { size: 'default' });
</script>

<template>
    <div
        class="flex gap-2 rounded-md border border-blue-100 bg-blue-50 text-blue-900"
        :class="size === 'small' ? 'p-2 text-caption' : 'p-4 text-body'"
    >
        <InfoIcon
            class="shrink-0 text-blue-500"
            :class="size === 'small' ? 'size-3.5 mt-px' : 'size-4 mt-0.5'"
        />
        <p><slot /></p>
    </div>
</template>
